import React from 'react'
import styled from 'styled-components'
import constants from '../../../constants/constants'

const S = {
    Profile: styled.div`
        display: flex;
        align-items: center;
        justify-content: start;
        cursor: pointer;
    `,

    Thumbnail: styled.img`
        width: 50px;
        height: 50px;
        border-radius: 30px;
        object-fit: cover;
    `,

    Name: styled.p`
        margin: 0;
        margin-left: 16px;
        font-size: 16px;
        font-weight: bold;
    `,
}

export interface ProfileInfo {
    first_name?: string
    last_name?: string
    name?: string
    mugshot?: string
}

const Profile = ({ user, onClick }: { user: ProfileInfo, onClick?: () => void }) => {
    const name = user.name ? user.name : `${user.first_name} ${user.last_name}`
    return (
        <S.Profile onClick={onClick || (() => {})}>
            <S.Thumbnail src={user.mugshot || constants.urlThumbnailDefault} alt={name} />
            <S.Name>{name}</S.Name>
        </S.Profile>
    )
}

export default Profile
